import React, { useEffect } from 'react'
import { Card, Spin } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { useUnit } from 'effector-react'
import dayjs from 'dayjs'

import { path } from '../../../../libs'
import { showNotification } from '../../../../features/notifications'
import {
  ChargebackForm,
  ChargebackFormData,
  toChargebackPayload,
} from '../widgets/ChargebackForm'
import {
  $chargeback,
  chargebackMounted,
  getChargeback,
  updateChargeback,
  updateChargebackMounted,
} from './model'

export const ChargebackEditPage: React.FC = () => {
  const navigate = useNavigate()
  const { chargebackID } = useParams()

  const chargeback = useUnit($chargeback)
  const isLoading = useUnit(getChargeback.pending)
  const isSaving = useUnit(updateChargeback.pending)

  useEffect(() => {
    if (chargebackID) {
      chargebackMounted({ id: chargebackID })
    }
  }, [chargebackID])

  useEffect(() => {
    const unsubscribeDone = updateChargeback.done.watch(() =>
      navigate(path.billing.chargeback.entry()),
    )
    const unsubscribeFail = updateChargeback.failData.watch((data) =>
      showNotification({
        type: 'error',
        message: 'Error',
        description: data.body.message,
        placement: 'topRight',
      }),
    )
    const unsubscribeLoadFail = getChargeback.failData.watch((data) =>
      showNotification({
        type: 'error',
        message: 'Error',
        description: data.body.message,
        placement: 'topRight',
      }),
    )
    return () => {
      unsubscribeDone()
      unsubscribeFail()
      unsubscribeLoadFail()
    }
  }, [navigate])

  const onSubmit = (data: ChargebackFormData) => {
    if (chargebackID) {
      updateChargebackMounted({
        id: chargebackID,
        payload: toChargebackPayload(data),
      })
    }
  }

  return (
    <Card
      className="mb-4"
      title={
        <strong>Edit chargeback {chargebackID ? `#${chargebackID}` : ''}</strong>
      }
    >
      {isLoading || !chargeback ? (
        <Spin />
      ) : (
        <ChargebackForm
            defaultValues={{
              walletId: String(chargeback.walletId),
              dateTime: dayjs(chargeback.dateTime),
              transactionId: String(chargeback.transactionId),
              amount: String(chargeback.amount),
              currency: chargeback.currency,
              chbCommission: String(chargeback.chbCommission),
              commissionCurrency: chargeback.commissionCurrency,
              exchangeRate:
                chargeback.exchangeRate == null
                  ? ''
                  : String(chargeback.exchangeRate),
              status: chargeback.status,
              comment: chargeback.comment ?? '',
            }}
            onSubmit={onSubmit}
            loading={isSaving}
            submitLabel="Save"
          />
      )}
    </Card>
  )
}
